import { createStore, combineReducers, applyMiddleware } from 'redux';

import treeLevelReducer from './reducers/treeLevelReducer';
import languageReducer from './reducers/languageReducer';
import appSettingsReducer from './reducers/appSettingsReducer';
import modalsReducer from './reducers/modalsReducer';
import { saveToLocalStorage } from '../services/localStorage';
import { loadData } from './utils';
import { STORAGE_KEYS } from '../constants/storageKeys';
import { languageMiddleware, setInitialLanguageMiddleware } from './middlewares';
import mapReducer from './reducers/mapReducer';
import type { RootState } from '../types/redux';

const persistedData = loadData();

const rootReducer = combineReducers({
    treeLevel: treeLevelReducer,
    language: languageReducer,
    appSettings: appSettingsReducer,
    modal: modalsReducer,
    map: mapReducer
});

const store = createStore(
    rootReducer,
    (persistedData ? { treeLevel: persistedData } : undefined) as undefined,
    applyMiddleware(languageMiddleware, setInitialLanguageMiddleware)
);

store.subscribe(() => {
    saveToLocalStorage(STORAGE_KEYS.TREE_LEVEL, { ...store.getState().treeLevel, _storeVersion: 2 });
});

export type AppDispatch = typeof store.dispatch;

export default store;
